import { store } from '../index';
import generateUniqueId from '../utils/generateUniqueId';

export const EATING_TAGS = 1;
export const DISH_TYPE_TAGS = 2;
export const CATEGORY_INGREDIENTS = 3;
export const TEMPLATE_PARAMETERS_TAG = 4;
export const VIDEO_TAGS = 5;
export const MOTIVATION_VIDEO_TAG = 6;
// add CATEGORY_FEMALE for man or woman and other tags
export const DEFAULT_MENU_DAYS_COUNT = 7;

export const DEFAULT_TRAINING_VIDEOS_PER_WEEK = [
  '1 День',
  '2 День',
  '3 День',
  '4 День',
  '5 День',
  '6 День',
  '7 День',
];
export const DEFAULT_TRAINING_VIDEOS_PER_WEEK_ADDITIONAL_INFO = [
  '(8, 15, 22)',
  '(9, 16, 23)',
  '(10, 17, 24)',
  '(11, 18, 25)',
  '(12, 19, 26)',
  '(13, 20, 27)',
  '(14, 21, 28)',
];
export const DEFAULT_COLOR_OF_TRAINING_VIDEOS = {
  1: '#17ade3',
  2: '#17ade3',
  3: '#17ade3',
  4: '#f5d601',
  5: '#17ade3',
  6: '#17ade3',
  7: '#17ade3',
};
export const DEFAULT_TYPE_OF_VIDEOS = [
  'Разминка',
  'Основное видео',
  'Заминка',
  'Саморазвитие',
  'Мотивация',
  'Приветствие',
  'FAQ',
];

export const DEFAULT_TYPE_OF_VIDEOS_DEFINITION_BY_ID = {
  1: 'Основное видео',
  2: 'Разминка',
  3: 'Заминка',
  4: 'Саморазвитие',
  5: 'Мотивация',
  6: 'Приветствие',
  7: 'FAQ',
};

export const MAIN_VIDEO_TYPE_ID = 1;
export const LIMBERING_UP_VIDEO_TYPE_ID = 2;
export const INTERRUPTION_VIDEO_TYPE_ID = 3;
export const SELF_DEVELOPMENT_VIDEO_TYPE_ID = 4;
export const MOTIVATION_VIDEO_TYPE_ID = 5;
export const WELCOME_VIDEO_TYPE_ID = 6;
export const FAQ_DEVELOPMENT_VIDEO_TYPE_ID = 7;

export const DEFAULT_TYPE_OF_VIDEOS_KEYS = [
  'limbering_up',
  'main_video',
  'interruption',
  'self_development',
  'motivation',
  'welcome',
  'faq',
];
export const DEFAULT_TYPE_OF_VIDEOS_FOR_REQUEST = {
  main_video: 'mainTrainingVideos',
  limbering_up: 'limberingUp',
  interruption: 'interruptions',
  self_development: 'selfDevelopment',
  motivation: 'motivation',
  welcome: 'welcome',
  faq: 'faq',
};

export const MEAL_TYPES_DICTIONARY = {
  morning: {
    title: 'Утро',
    order: 0,
    time: null,
    tag_id: 15,
  },
  breakfast: {
    title: 'Завтрак',
    order: 1,
    time: '+ 20 мин',
    tag_id: 86,
  },
  breakfastSnack: {
    title: 'Перекус',
    order: 2,
    time: '+ 1,5 часа',
    tag_id: 9,
  },
  lunch: {
    title: 'Обед',
    order: 3,
    time: '+ 1,5 часа',
    tag_id: 87,
  },
  lunchSnack: {
    title: 'Второй перекус',
    order: 4,
    time: '+ 2 часа',
    tag_id: 90,
  },
  dinner: {
    title: 'Ужин',
    order: 5,
    time: '+ 2 часа',
    tag_id: 88,
  },
  dinnerSnack: {
    title: 'Вечерний перекус',
    order: 14,
    time: 'За 2 часа до сна',
    tag_id: 89,
  },
};

export const MEAL_DEFAULT_TIMES = {
  morning: null,
  breakfast: '+ 20 минут',
  breakfastSnack: '+ 1,5 часа',
  lunch: '+ 2 часа',
  lunchSnack: '+ 2 часа',
  dinner: '+ 1,5 часа',
  dinnerSnack: '+ 2 часа',
};

export const WATER = {
  avg_weight: 200,
  calories: 0,
  carbohydrates: 0,
  fats: 0,
  id: 121,
  image: 'null',
  max_weight: 350,
  min_weight: 150,
  name: 'Вода',
  parent_id: null,
  priority: 1,
  proteins: 0,
  recepie: {
    calories: '0',
    carbohydrates: '0',
    dish_id: 121,
    fats: '0',
    id: 518,
    products: [],
    proteins: '0',
    text: null,
  },
  tags: [
    {
      can_delete: false,
      category_id: 1,
      created_at: '2018-09-25 15:02:01',
      name: 'Утро',
      normalized: 'utro',
      pivot: {
        taggable_id: 121,
        tag_id: 15,
        taggable_type: 'AppModelsDish',
        created_at: '2021-03-12 10:46:00',
        updated_at: '2021-03-12 10:46:00',
      },
      tag_id: 15,
      updated_at: '2021-03-18 16:22:49',
    },
  ],
};

export const getDefaultMeals = (time = '+ час') => {
  return [
    {
      id: generateUniqueId(), // generate unique id
      dish: WATER,
      counted_calories: 0,
      counted_carbohydrates: 0,
      counted_fats: 0,
      counted_proteins: 0,
      quantity: 200,
      time,
    },
  ];
};

export const getDefaultMenu = (daysNumber) => {
  const DEFAULT_MENU = [];
  let daysCount = daysNumber || DEFAULT_MENU_DAYS_COUNT;
  if (store && window.location.pathname === '/' && !daysNumber) {
    daysCount = store.getState().menu.selectedDayCount;
  } else if (store && window.location.pathname === '/templateGenerator') {
    daysCount = store.getState().templateGenerator.countTemplateDays;
  }

  for (let i = 0; i < daysCount; i++) {
    DEFAULT_MENU.push([
      {
        meals: getDefaultMeals('Натощак'),
        order: 0,
        title: 'Утро',
        type: 'morning',
      },
      {
        meals: getDefaultMeals(),
        order: 1,
        title: 'Завтрак',
        type: 'breakfast',
      },
      {
        meals: getDefaultMeals(),
        order: 2,
        title: 'Перекус',
        type: 'breakfastSnack',
      },
      {
        meals: getDefaultMeals(),
        order: 3,
        title: 'Обед',
        type: 'lunch',
      },
      {
        meals: getDefaultMeals(),
        order: 4,
        title: 'Второй перекус',
        type: 'lunchSnack',
      },
      {
        meals: getDefaultMeals(),
        order: 5,
        title: 'Ужин',
        type: 'dinner',
      },
      {
        meals: [],
        order: 6,
        title: 'Вечерний перекус',
        type: 'dinnerSnack',
      },
    ]);
  }
  return DEFAULT_MENU;
};

export const DEFAULT_HEIGHT_GENERATION = 170;
export const DEFAULT_WEIGHT_GENERATION = 80;
export const DEFAULT_AGE_GENERATION = 40;
export const DEFAULT_GENDER_GENERATION = 3;
export const DEFAULT_GOAL_GENERATION = 55;
export const DEFAULT_ACTIVITY_GENERATION = 1.2;
export const DEFAULT_CALORIES_GENERATION = 1600;

// MENU PAGE
export const SMALLER_DAY_VIOLATION = 'small';
export const BIGGEST_DAY_VIOLATION = 'biggest';
export const NONE_DAY_VIOLATION = 'none';
export const PERCENTAGE_MAX_CALORIES = 10;

export const DEFAULT_COMPLEX_TYPE = [
  { value: 1, label: 'Индивидуальный' },
  { value: 0, label: 'Базовый' },
];
export const DEFAULT_ACTIVITY_COEFFICIENT = 1.2;
export const COMPLEX_PAUSE_ID = 4;
export const COMPLEX_ACTIVE_ID = 3;



// WEBPACK FOOTER //
// ./src/constants/appConstants.js